import { getHistory, PATCH_HISTORY } from '../../components/NotificationsHistory/actions'
import { newToast } from '../../components/shared/toast-stack/actions'
import { getIdToken } from '../cognito'
import http from '../http'
import { getStore } from '../state'
import NchanSubscriber from '../vendor/NchanSubscriber'

import { handleIncomingMessageNotification, handleAlertNotification } from './handle-notification'

let subscriber = null

export const stopPubsubListening = () => {
  if (!subscriber) {
    console.error('No PubSub subscriber available')
    return
  }

  try {
    subscriber.stop()
  } catch (err) {
    console.error(err)
  }

  subscriber = null
}

export const startPubsubListening = () => {
  if (subscriber) {
    console.info('PubSub subscriber already initialized')
    return
  }

  subscriber = new NchanSubscriber(`${http.BASE_URL}/listen`, {
    subscriber: 'longpoll',
    reconnect: 'persist',
    shared: true
  })

  subscriber.on('transportNativeBeforeCreate', (transport, name, cb) => {
    if (name !== '__slave') {
      getIdToken()
        .then(idToken => {
          transport.headers.Authorization = `Bearer ${idToken}`
          cb()
        })
        .catch(e => {
          console.info(e)
        })
    }
  })

  subscriber.on('message', (msgStr /* , messageMetadata */) => {
    if (msgStr && msgStr.length > 0) {
      const notif = JSON.parse(msgStr)

      const store = getStore()

      if (notif.type === 'chat_message') {
        handleIncomingMessageNotification(notif.payload)
          .catch((error) => {
            console.error(error)
          })

        return
      }

      store.dispatch({
        type: PATCH_HISTORY,
        notifications: [ notif ]
      })

      switch (notif.type) {
        case 'patient_ineligible':
          store.dispatch(newToast({
            ...notif.payload,
            type: notif.type
          }))
          break
        case 'alert_escalated':
        case 'alert_owned': {
          handleAlertNotification(notif.payload, { showAlert: notif.type === 'alert_escalated' })
          break
        }
        case 'symptoms_reported':
        case 'issue_assigned':
        case 'igao_published':
        case 'new_file':
          store.dispatch(newToast(notif))
          break
        default:
          console.error('Received notification with unknown type', notif)
      }

      if (notif.history) {
        store.dispatch(getHistory())
      }
    }
  })

  subscriber.on('error', error => {
    if (error === 403 || error === 401) {
      setTimeout(() => {
        stopPubsubListening()
        startPubsubListening()
      }, 500)
    }
  })

  subscriber.start()
}
